/**
 * @file
 * This file contains all the js required for clevertap event functionalit and validation
 *
 * The theme system allows for nearly all output of the Drupal system to be
 * customized by user themes.
 */

// const { find } = require("lodash");

 // Cleveer Tap
 var clevertap = {
  event: []
  , profile: []
  , region: 'in1'
  , account: []
  , onUserLogin: []
  , notifications: []
  , privacy: []
};
// replace with the CLEVERTAP_ACCOUNT_ID with the actual ACCOUNT ID value from your Dashboard -> Settings page 
clevertap.account.push({
  "id": clevertap_id
});


// var clevertap = { event: [], profile: [], region: 'in1', account: [], onUserLogin: [], notifications: [], privacy: [] };
// replace with the CLEVERTAP_ACCOUNT_ID with the actual ACCOUNT ID value from your Dashboard -> Settings page
// clevertap.account.push({ "id": "WWW-65W-9W6Z" });
clevertap.privacy.push({ optOut: false }); //set the flag to true, if the user of the device opts out of sharing their data
clevertap.privacy.push({ useIP: true }); //set the flag to true, if the user agrees to share their IP data
(function () {
  var wzrk = document.createElement('script');
  wzrk.type = 'text/javascript';
  wzrk.async = true;
  wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/a.js';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wzrk, s);
})();

if(memberId==false || memberId=='false'){
  memberId="";
}
var onUserLogin={"identity": memberId};
if(userName==false || userName=='false'){
  userName="";
}else{
  onUserLogin.Name=userName;
}

if(userEmailId==false || userEmailId=='false'){
  userEmailId="";
}else{
  onUserLogin.Email=userEmailId;
}

if(userMobileNo==false || userMobileNo=='false'){
  userMobileNo="";
}
else{
  userMobileNo="+"+userMobileNo;
  onUserLogin.Phone=userMobileNo;
}
// console.log(onUserLogin);
clevertap.onUserLogin.push({
  
  // "Site": {
  //   "Name": userName ,
  //   "Email": userEmailId,         // Email address of the user
  //   "Phone": userMobileNo,
  //   "identity": memberId,
  // }
  "Site":onUserLogin
});

function clevertapEventCall(event, params={}) {
  if(memberId==false || memberId=='false'){
    memberId="";
  }
  uid = (uid==false || uid=='false')?'':uid;
  // console.log('memberId: '+memberId);
  clevertap.profile.push({
    "Site": {
      "identity": memberId,
      "platform": "Web",
      "UserID": uid
    }
  });
  event="Ecom " + event;
  console.log(event);
  userName = (userName==false || userName=='false')?'':userName;
  userMobileNo = (userMobileNo==false || userMobileNo=='false')?'':userMobileNo;
  userEmailId = (userEmailId==false || userEmailId=='false')?'':userEmailId;
  userPincode = (userPincode==false || userPincode=='false')?'':userPincode;
  userCity = (userCity==false || userCity=='false')?'':userCity;
  userState = (userState==false || userState=='false')?'':userState;
 
  userMemberId = (userMemberId==false || userMemberId=='false')?'':userMemberId;
  var isLogin = $('#login_ctx').attr('ctx') == 'true' ? 1 : "";
  var page =  $(location).attr("href");
    params["Name"]= userName;
   
    // params["Mobile Number"]= userMobileNo;
    // params["E-Mail ID"]=  userEmailId;
    params['ClevertapID']=ClevertapSdkId;//clevertap.getCleverTapID();
    params["Pincode"]=  userPincode;
    params["City"]= userCity;
    params["State"]= userState
    params["UID"]= uid;
    params["MemberID"]= userMemberId;
    params["IsLogin"]= isLogin;
    params["Page URL"]= page;
    params["Page Source"]= getSource();
    clearBlankData(params);
    console.log(params);
    
  return clevertap.event.push(event, params);
}
function getSource() {
  let preSource = "Home";
    if(prevUrl.includes("resorts")){
      preSource = "Resorts";
    }
    else if(prevUrl.includes("magical-membershipmagic")){
      preSource = "Membership";
    }
    else if(prevUrl.includes("magical-experience")){
      preSource = "Experience";
    }
    else if(prevUrl.includes("magical-magic-testimonials")){
      preSource = "Testimonials";
    }
    else if(prevUrl.includes("buy-membership")){
      preSource = "Buy Membership";
    }
    else if(prevUrl.includes("resort/club")){
      preSource = "Iternary";
    }
    return preSource;

}
function isEmpty(str) {
  return (!str || str.length === 0 || /^\s*$/.test(str) || str === "");
}
function clearBlankData(params) {
  jQuery.each(params, function (key, value) {
    if (value === "" || value === null || isEmpty(value) || value === "false") {
      delete params[key];
    }
  });

  return params;
}

function clearZeroParamData(params) {
  jQuery.each(params, function (key, value) {
    if (value === 0) {
      delete params[key];
    }
  });
  return params;
}

/*************** Join the club buttion clicked **************/
function joinTheClubClicked(btnCat='Top Menu',bannerName='') {
  var params = {
    "Source": btnCat,
    "Banner Number": bannerName
  }; 
 
  clevertapEventCall("Buy Now Clicked", params);
}
/********************************* */
function sliderArrowClicked(arrow='',info='') {
  var params = {
    "Button Clicked": arrow,
    // "Banner Number": bannerName
  }; 
 
  clevertapEventCall("Personalization Corousal Click", params);
}
/***************  Recommended Holidays For You clicked **************/
function RecommendedHolidaysClicked(tab='') {
  var params = {
    "Tab": tab
  };
    clevertapEventCall("Recommended Holidays For You Clicked", params);
}


/*************** Discover Resorts Card Clicked **************/
$(document).on('click', '.populerSlideClick', function (e) {
  var resortId=$(this).attr('data-resortId');
  var resortName=$(this).attr('data-resortName');
  var state=$(this).attr('data-state');
  var region=$(this).attr('data-region');
  var terrain=$(this).attr('data-terrain');
  var params = {
    "Resort id": resortId,
    "Resort Name": resortName,
     "Resort State": state,
     "Region": region,
     "Terrain": terrain,
  };
  clevertapEventCall("Discover Resorts Card Clicked", params);
});


 /*************** Resort 360 clicked **************/
 $(document).on('click', '.dis-p-icon', function (e) {
  var resortName=$('.currentOnHover').find('.btm-img-text').text();
  var resortId=$('.currentOnHover').find('.btm-img-text').data('resort_id');
  var params = {
    "Resort Name": resortName,
    "Resort Id": resortId
  };
  clevertapEventCall("Experience 360 Degree Resort Clicked ", params);
});

$(document).on('click', '.sa-live-call-widget-btn', function (e) {
  clevertapEventCall("Chat Bot Clicked");
});
$(document).on('click', '#sa-live-call-widget-video_call-btn', function (e) {
  clevertapEventCall("Chat Video Call Clicked ");
});

  /*************** Resort 360 clicked **************/
  jQuery('#topmenu ul li').on('click', '.item-name', function () {
    var topmenu = $(this).html();
    var params = {
      "Tab Clicked": topmenu,
    };
    clevertapEventCall("Top Menu Clicked", params);
  });
  
  /***************  Unique Experiences Card Clicked **************/
  $('.card-exp-gal').click(function(e){
    var params = {
      "Card Clicked": $(this).find('figcaption').text()
    };
    clevertapEventCall("Unique Experiences Card Clicked", params);
  });
    

  /***************  Resort List clicked **************/
  function ResortListClicked( resort,state, region,terrain) {
    var params = {
      "Resort Name": resort,
      "State": state,
      "Region": region,
      "Terrain": terrain,
      "Search Keyword": $("#searchInput").val()
    };
    clearBlankData(params);
    clevertapEventCall("Resort Page Card Clicked", params);
  }
  /***************  Resort List page search clicked **************/
  function ResortListPageSearchClicked(keyword) {
    var page = 'Home';
    var params = {
      "Search Keyword": keyword,
      "Region": $("#zone-search").val(),
      "Terrain": $("#terrain-search").val(),
    };
    clevertapEventCall("Resort Page Search Clicked", params);
  }
  $("#zone-search").change(function(){
    var params = {
      "Region Selected": $(this).val()
    };
    clevertapEventCall("Resort Page Region Selected", params);
  });
  $("#terrain-search").change(function(){
    var params = {
      "Terrain Selected": $(this).val()
    };
    clevertapEventCall("Resort Page Terrain Selected", params);
  });
  /***************  FAQ clicked **************/
  function faqClicked(que) {
    var params = {
      "FAQ": que
    };
    clevertapEventCall("FAQ Clicked", params);
  }

  /***************  Make Payment clicked **************/
  function MakePaymentClicked(cost,offer,gst,net,coupon=false) {
   var params = {
      "Membership cost": cost,
      "Offer Discount": offer,
      "GST": gst,
      "Payable Amount": net,
      "Apply Coupon": coupon
    };
    clevertapEventCall("Buy Now Pay Now Clicked", params);
  }
  function AddGifteeClicked(cost,offer,gst,net,coupon=false) {
    var params = {
       "Membership cost": cost,
       "Offer Discount": offer,
       "GST": gst,
       "Payable Amount": net,
       "Apply Coupon": coupon
     };
     clevertapEventCall("Add Giftee Clicked", params);
   }

/*************** Resort Page Stories clicked **************/
function ResortPageStoriesVideoClicked(name,position,state,resort_id,region,terrain,source) {
  var params = {
    // "name": userName,
    "Video Position": position,
    "Resort State": state,
    "Resort Name": name,
    "Resort Id": resort_id,
    "Region": region,
    "Terrain": terrain,
    "source": source,
  };
  clearBlankData(params);
  clevertapEventCall("Resort Page Interesting Stories Video Clicked", params);
}
/*************** Resort Page Experience Tab clicked **************/
function ResortPageExperienceTabClicked(resort,tab,state) {
  var params = {
    // "Mobile Number": userMobileNo,
    "Resort State": state,
    "Resort Name": resort,
    "Tab Name": tab
  };
  clearBlankData(params);
  clevertapEventCall("Resort Page Experiences Tab Clicked", params);
}
function ResortPageAmenitiesTabClicked(resort,tab,state) {
  var params = {
    // "Mobile Number": userMobileNo,
    "Resort State": state,
    "Resort Name": resort,
    "Tab Name": tab
  };
  clearBlankData(params);
  clevertapEventCall("Resort Page Amenities Tab Clicked", params);
}
function ResortPageFAQClicked(id,name,que,state,region,terrain) {
  var params = {
    "Resort ID": id,
    "Question Clicked": que,
    "Resort State": state,
    "Resort Name": name,
    "Region": region,
    "Terrain": terrain,
  };
  clearBlankData(params);
  clevertapEventCall("Resort Page FAQ Question Expand Clicked", params);
}


/*************** call with Us Click Submit Click **************/
function callWithUsSubmitClick(name,mob) {
  var params = {
    "Lead Full Name ": name,
    "Lead Mobile Number": mob
  };
  clevertapEventCall("call Receive A Call Back Submit Clicked", params);
}
/*************** Customise Package Click **************/
$(document).on('click','.colMain',function(e){
  var pkgName=$(this).find('h4').text();
  var cards=$(this).find('.subcol-wrap .subCol');
  var expCard=$(this).find('.mustexp .minslider .active .slideminwrap');
  var rList='';
  var i=0;
  cards.each(function( index ) {
    if(i>0){
      rList +=', ';
    }
    rList +=$( this ).find('h5').text();
    i++;
  });
  var exp='';
  var i=0;
  expCard.each(function( index ) {
    if(i>0){
      exp +=', ';
    }
    exp +=$( this ).find('span').text();
    i++;
  });
  var tab='Be an explorer';
  if ($(".itinerary-b").hasClass("current")) {
    tab='Holiday the way you like';
  }
  CustomisePackageClick(pkgName,rList,exp,tab);
});
function CustomisePackageClick(pkgName,rList,exp,tab) {
  var params = {
    "Package Name": pkgName,
    "Resort List": rList,
    "Curated Experience": exp,
    "Tab": tab
  };
  clearBlankData(params);
  clevertapEventCall("Itinerary Click", params);
}

/***************  Sign Up clicked **************/
function SignUpClicked(action) {
  var params = payNowPageData();
  params.User_action = action;
  clevertapEventCall("Buy Now Pay Now Sign In Clicked", params);
}
/***************  Login Box clicked **************/
function LoginBoxViewed(action) {
  var params = {
    "User Action": action
  };
  clevertapEventCall("Login-Signup Clicked", params);
}
/***************  Generate OTP clicked **************/
function generateOTPClicked(action,str,userAction=null) {

  var params = payNowPageData();
  //params.Login_via = action;
  params.User = str;
  clevertapEventCall("Buy Now Pay Now Generate OTP Clicked", params);
}
/***************  Sign Up submit clicked **************/
function submitSignUp(params) {
  clevertapEventCall("Buy Now Pay Now Sign Up Clicked", params);
}
/***************  OTP Box Viewed **************/
function OTPViewed(action,str) {
  if(action=='email'){
    var params = {
      "Login via": action,
      "User Email": str
    };
  }else{
    var params = {
      "Login via": action,
      "User Mobile": str,
    };
  }
  clevertapEventCall("OTP Pop Up Showed", params);
}
/***************  OTP Box Viewed **************/
function ResendOTPClicked(mob) {  
    var params = {
      "Resend OTP TO": mob
    };
  clevertapEventCall("Resend OTP Pop Up Clicked", params);
}
/***************  OTP Proceed Clicked **************/
function otpProceedClicked(msg,str) {
  var params={
      "Login Through": str,
      "Message": msg
    };
  
  clevertapEventCall("OTP Proceed Clicked", params);
}
$(document).on('click','#sa-live-call-widget-lead-capture-form-microphone-permission-btn', function () {
  var formData = $("#sa-live-call-widget-lead-capture-form").serializeArray().reduce(function(obj, item) {
      if(item.name == "text-1697794947983-0"){ item.name = "email"; }
      obj[item.name] = item.value;
      return obj;
  }, {});
  var countryCode = $(".sa-live-call-widget-selected-country").text();
  clevertap.onUserLogin.push({
  
    "Site": {
      "Chat Name": formData.name ,
      "Chat Email": formData.email,         
      "Chat Phone": countryCode + formData.mobile_number,
      "Name": formData.name ,
      "Email": formData.email,         
      "Phone": countryCode +  formData.mobile_number
    }
  });

 var params = { 
      "User" : {
        "Name": formData.name ,
        "Email": formData.email,         
        "Phone": countryCode +  formData.mobile_number
      }
  };
  clevertapEventCall("Chat Video Call Grant Permission Clicked", params);
});

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

/***************  OTP closed Clicked **************/
$(".otp-close").click(function(){
  var id=$('#mobileInoBox').text();
  if(isEmail(id)){
    var params={
        "Enterd Email Id": id
      };
  }
  else{
    var params={
      "Enterd Mobile Number": id
    };
  }
  
  clevertapEventCall("OTP Closed", params);
});

$(".signup-close").click(function(){
    var params={
        "Enterd first name": $('#first_name').val(),
        "Enterd last name": $('#last_name').val(),
        "Enterd email": $('#email').val(),
        "Enterd mobile no.": $('#mobile_no').val(),
        "Enterd pin no.": $('#pin_code').val(),
        "Enterd city name": $('#city_name').val(),
        "Enterd state": $('#state').val()
      };
  clevertapEventCall("Share your Details closed", params);
});

$(".pay-now").click(function(){
  var params = payNowPageData();
  clevertapEventCall(" Buy Now Pay Now Clicked", params);
});
$("#openpdf").click(function(){
  var params = payNowPageData();
  clevertapEventCall("Buy Now Pay Now T&C Clicked", params);
});
$(document).on("click","#proceedBtn",function(){
  var params = payNowPageData();
  clevertapEventCall("Buy Now Pay Now Confirm & Proceed Clicked", params);
});

function offerDetailClicked(){
  var params = payNowPageData();
  clevertapEventCall("Buy Now Select Offer Clicked", params);
}
function payNowPageData(){
  var dp_plan = $('#selectedDP').val();
  if (dp_plan == '100') {
      var emi = $("#emiTennure").val();
  } else {
      var emi = $("#emi").val();
  }
  var prodType = $('#productType').val();
  var prodName = $('#prodName').val();
  var season = $("#season").val();
  var appartment = $('#apartment').val();
  var channel = $('#channel').val();
  var emiAmt = $('#emiAmt').val();
  var interestRate = $('#interestRate').val();
  var asfAmt = $('#asfAmt').val();
  var prodPrice = $('#prodPrice').val();
  var initalDPToBePaid = $('#initalDPToBePaid').val();
  var controlLocation = $('#controlLocation').val();
  var is_active = $('#is_active').val();
  var tnc_chk = $('#tnc_chk').val();
  var payment_clk = $('#payment_clk').val();
  var userProductURL = $('#userProductURL').val();
  var selectedPremiumOption = $('#selectedPremiumOption').val();
  var selectedOfferName = $('#selectedOfferName').val();
  var prodMasterTd = $('#prodMasterTd').val();
  var params={
    "Down Payment Plan": dp_plan,
    "Product Type": prodType,
    "Product Name": prodName,
    "Season": season,
    "Apartment": appartment,
    "Offer Selected": selectedOfferName,
    "Total Cost": prodPrice,
    "EMI Amount": emiAmt,
    "ASF Amount": asfAmt,
    "Down Payment Amount": initalDPToBePaid,
    "EMI tenure": emi
  };
  return params;
}

jQuery(document).on('click', '.banner-section .top-slider .owl-prev', function () {
  var banner = $('.owl-item.active .banner');
  var params = {
    "Arrow Clicked": 'Backward',
    "Card Displayed": banner.data('title'),
    "Card Displayed Description": banner.data('description')
  };
  clevertapEventCall("Homepage Banner Arrow Clicked", params);

});
jQuery(document).on('click', '.banner-section .top-slider .owl-next', function () {
  var banner = $('.owl-item.active .banner');
  var params = {
    "Arrow Clicked": 'Forward',
    "Card Displayed": banner.data('title'),
    "Card Displayed Description": banner.data('description')
  };
  clevertapEventCall("Homepage Banner Arrow Clicked", params);
});

//Member Benefits Card Arrow Clicked
  jQuery(document).on('click', '#benefits-slider .owl-next', function () {
    var totalItems = $('#benefits-slider .owl-stage-outer .owl-stage .owl-item').length;
    var currentIndex = $('#benefits-slider .owl-stage-outer .owl-stage .owl-item.active').index() + 1;
    var params = {
      "Arrow Clicked": 'Forward',
      "Number Of Cards": rangeOfNumbers(currentIndex,currentIndex +2).toString(),
      // "Card Displayed Description": banner.data('description')
    };
    clevertapEventCall("Member Benefits Card Arrow Clicked", params);
  });
  const rangeOfNumbers = (a,b) => [...Array(b+1).keys()].slice(a);
  jQuery(document).on('click', '#benefits-slider .owl-prev', function () {
    // var slider = $('#benefits-slider').find('.owl-item.active .banner');
    var totalItems = $('#benefits-slider .owl-stage-outer .owl-stage .owl-item').length;
    var currentIndex = $('#benefits-slider .owl-stage-outer .owl-stage .owl-item.active').index() + 1;
    var params = {
      "Arrow Clicked": 'Backward',
      "Number Of Cards": rangeOfNumbers(currentIndex,currentIndex +2).toString(),
      // "Card Displayed Description": banner.data('description')
    };
    clevertapEventCall("Member Benefits Card Arrow Clicked", params);
  });
//=============================================================

//Discover Resorts Arrow Clicked
  jQuery(document).on('click', '#popular-slides .owl-next', function () {
    var params = {
      "Arrow Clicked": 'Forward'
    };
    clevertapEventCall("Discover Resorts Arrow Clicked", params);
  });
  jQuery(document).on('click', '#popular-slides .owl-prev', function () {
    var params = {
      "Arrow Clicked": 'Backward',
    };
    clevertapEventCall("Discover Resorts Arrow Clicked", params);
  });
//=============================================================


//Buy Now Page Banner Arrow Clicked
  jQuery(document).on('click', '#pay-slider .owl-nav .owl-prev', function () {
    var banner = $('.owl-item.active .banner');
    var params = {
      "Arrow Clicked": 'Backward',
      "Card Displayed": banner.data('title'),
      //"Card Displayed Description": banner.data('description')
    };
    clevertapEventCall("Buy Now Page Banner Arrow Clicked", params);

  });
  jQuery(document).on('click', '#pay-slider .owl-nav .owl-next', function () {
    var banner = $('.owl-item.active .banner');
    var params = {
      "Arrow Clicked": 'Forward',
      "Card Displayed": banner.data('title'),
      //"Card Displayed Description": banner.data('description')
    };
    clevertapEventCall("Buy Now Page Banner Arrow Clicked", params);
  });
//=============================================================

//Resort Page Arrow Clicked
jQuery(document).on('click', '#review-slider .owl-nav .owl-prev', function () {
  var banner = $('.owl-item.active .banner');
  var params = {
    "Arrow Clicked" : 'Backward',
    "Resort State"   : $('#stateName').val(),
    "Resort Name"   : $('#resortName').val(),
    "Resort ID"  : $('#resort_id').val(),
    "Region"  : $('#region').val(),

    "Terrain"  : $('#terrain').val()
  };
  clevertapEventCall("Resort Page Arrow Clicked", params);

});
jQuery(document).on('click', '#review-slider .owl-nav .owl-next', function () {
  var banner = $('.owl-item.active .banner');
  var params = {
    "Arrow Clicked" : 'Forward',
    "Resort State"   : $('#stateName').val(),
    "Resort Name"   : $('#resortName').val(),
    "Resort ID"  : $('#resort_id').val(),
    "Region"  : $('#region').val(),

    "Terrain"  : $('#terrain').val()

  };
  clevertapEventCall("Resort Page Arrow Clicked", params);
});
//=============================================================

//experience 360 Degree Arrow Clicked
jQuery(document).on('click', '#thumb360 .owl-nav .owl-prev', function () {
  var params = {
    "Arrow Clicked" : 'Backward',
  };
  clevertapEventCall("experience 360 Degree Arrow Clicked", params);

});
jQuery(document).on('click', '#thumb360 .owl-nav .owl-next', function () {
  var params = {
    "Arrow Clicked" : 'Forward',
  };
  clevertapEventCall("experience 360 Degree Arrow Clicked", params);
});
//=============================================================

// Member Experience Arrow Clicked
jQuery(document).on('click', '.exp-slider .owl-nav .owl-prev', function () {
  var position = $(this).closest('.exp-slider').data('title');
  var params = {
    "Arrow Clicked" : "Backward",
    "Arrow Position" : position
  };
  clevertapEventCall("Member Experience Arrow Clicked", params);

});
jQuery(document).on('click', '.exp-slider .owl-nav .owl-next', function () {
  var position = $(this).closest('.exp-slider').data('title');
  var params = {
    "Arrow Clicked" : "Forward",
    "Arrow Position" : position
  };
  clevertapEventCall("Member Experience Arrow Clicked", params);
});
//=============================================================




jQuery(document).on('click', '#testimonial-slider1 .owl-stage-outer .owl-stage .owl-item', function () {
  var i = $(this).index();
  i = i + 1;
  var params = {
    "Video Title" : $(this).find('h6').text(),
    "Position" : i

  };
  clevertapEventCall("Member Experience Video", params);

});











function productSectionClick(){
  var params = payNowPageData();
  clevertapEventCall("Buy Now Product Detail Clicked", params);
}
function paymentSectionClick(){
  var params = payNowPageData();
  clevertapEventCall("Buy Now Payment Detail Clicked", params);
}



//old events

// landing page lode event
function landingPageVisit() {
  var pageURL = $(location).attr("href");
  var pageTap = $(location).attr('href').split("/").splice(4, 1).join("/");
  // var resortName = $(location).attr('href').split("/").splice(5, 1).join("/");
  // console.log(resortTap+ "=="+resortName);
  // if(resortTap=='resort' && resortName!=undefined){
    var resortPageArray=["resort","itenary"];
    if(resortPageArray.indexOf(pageTap) >= 0){
      pageTap="Resort";
    }
    if(pageTap=="resorts" || pageTap=="populer-resort"){
      pageTap="Resort list";
    }
    if(!pageTap || pageTap.length === 0 || pageTap===""){
      pageTap="Home";
    }
    
    var params = {
      "Page Type": pageTap,
      "Page URL": pageURL
    };
  
  
  clearBlankData(params),
    clevertapEventCall("Page Visit", params)
}
